module.exports = {
  text: `Тела убитых красно-коричневой плесенью дают жизнь новым плесневикам. Не совсем то наследие, к которому стоит стремиться. `,
  author: `Эльминстер`,
}
